import AppService from './appService'
import type { ContextStore } from '@/stores/context'
import { Order, OrderPaymentPending } from '@/types/orders.interface'

export default class OrderService extends AppService {
  constructor(appContext: ContextStore) {
    super(appContext)
  }

  async fetchCreateOrder(productId: string): Promise<Order> {
    const data = {
      accounts_token: this.context.accountsToken,
      currency: this.context.currency,
      product_id: productId,
    }

    const res = await this.mboApiV1.post('orders', data)
    return res.data
  }

  async fetchPendingChargebeeHostedPage(): Promise<OrderPaymentPending> {
    const params = {
      accounts_token: this.context.accountsToken,
    }

    const res = await this.mboApiV1.get('orders/payment/pending', { params })

    return res.data
  }
}
